import { render } from "./ScpmMoreActions.vue?vue&type=template&id=2c68728e&scoped=true"
import script from "./ScpmMoreActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ScpmMoreActions.vue?vue&type=script&setup=true&lang=js"

import "./ScpmMoreActions.vue?vue&type=style&index=0&id=2c68728e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c68728e"],['__file',"src/components/scpm/common/ScpmMoreActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c68728e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c68728e', __exports__)) {
    api.reload('2c68728e', __exports__)
  }
  
  module.hot.accept("./ScpmMoreActions.vue?vue&type=template&id=2c68728e&scoped=true", () => {
    api.rerender('2c68728e', render)
  })

}


export default __exports__